import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ColorSimulator from '../components/ColorSimulator';

const CrowdPreview = () => (
  <div className="min-h-screen bg-black pt-24 pb-16 px-4 sm:px-6" data-testid="crowd-preview-page">
    <div className="max-w-6xl mx-auto">
      <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-white text-sm transition-colors" data-testid="crowd-preview-back">
        <ArrowLeft className="w-4 h-4" /> Party LED
      </Link>

      <div className="mt-6 mb-2 rounded-xl border border-purple-500/30 bg-purple-600/10 px-5 py-4">
        <p className="text-purple-300 text-xs uppercase tracking-[0.25em] mb-1">Aperçu privé</p>
        <p className="text-gray-300 text-sm leading-relaxed">
          Cette page n'est pas visible sur le site : aucun lien n'y mène et elle n'est pas référencée.
          Essayez le mode « Foule (50 bracelets) » avec les différentes couleurs et effets, puis dites-moi
          si je l'active sur la page d'accueil et les fiches kit.
        </p>
      </div>

      <ColorSimulator allowCrowd defaultCrowd />
    </div>
  </div>
);

export default CrowdPreview;
